import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {noPropagate} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {LinkButtonAdd} from '../link-button-add'
import {NewTaskEditorInput} from './add-subtask'
import {useStore} from './subtasks-store'

interface Props {
  className?: string
  withoutHover?: boolean
  onEndAdd?: () => void
}

export const CreateSubtaskButton = observer((props: Props) => {
  const {className, withoutHover = false, onEndAdd} = props

  const [state, store] = useStore()

  if (state.showNewTaskInput) {
    return (
      <div className="w-full mr-8">
        <NewTaskEditorInput
          stayOpen
          onEndAdd={onEndAdd}
          withoutHover={withoutHover}
        />
      </div>
    )
  }

  const onClick = (e: React.MouseEvent) => {
    noPropagate(e)
    store.setShowNewTaskInput(true)
  }

  return (
    <LinkButtonAdd
      onMouseDown={onClick}
      className={cn('mt-8', className)}
      text={Lang.msg.subtask.createSubtask}
      type={'circle'}
    />
  )
})
